export * from './src/payments-mcp-v1-wix-payments-account-wix-payments-account.universal.js';
